const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20drama%20series%20poster%20style%20image%20with%20warm%20orange%20and%20amber%20tones%2C%20modern%20Chinese%20TV%20drama%20aesthetic%2C%20emotional%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20elegant%20composition&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '电视剧',
    title: '红桃视频热播剧 · 年度口碑之作',
    desc: '全网热度爆表的精品剧集，剧情紧凑演技在线，追剧党不可错过的年度佳作',
    platform: '红桃视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20series%20style%20poster%20with%20dark%20and%20warm%20contrasting%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20composition%2C%20modern%20Chinese%20drama%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '悬疑',
    title: '樱桃视频悬疑剧场 · 烧脑神作合集',
    desc: '高智商推理剧情层层反转，每一集都让人欲罢不能，悬疑迷的终极盛宴',
    platform: '樱桃视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20trendy%20modern%20short%20drama%20series%20poster%20style%20with%20vibrant%20warm%20colors%2C%20youthful%20energy%2C%20contemporary%20urban%20setting%2C%20cinematic%20lighting%2C%20stylish%20composition&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '短剧',
    title: '茄子视频短剧精选 · 每日更新不断',
    desc: '短小精悍的热门短剧每日上新，碎片时间追剧首选，轻松追完不费时',
    platform: '茄子视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20variety%20show%20style%20poster%20with%20bright%20cheerful%20warm%20tones%2C%20entertainment%20atmosphere%2C%20colorful%20and%20lively%20composition%2C%20modern%20Chinese%20TV%20show%20aesthetic&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '综艺',
    title: '糖心视频综艺大全 · 热门综艺一网打尽',
    desc: '搞笑、竞技、访谈各类综艺应有尽有，欢乐不停歇，周末放松最佳选择',
    platform: '糖心视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20historical%20costume%20drama%20poster%20style%20with%20elegant%20warm%20amber%20tones%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20composition%2C%20soft%20natural%20lighting%2C%20refined%20artistic%20style&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '古装',
    title: '红桃视频古装剧场 · 经典国风大剧',
    desc: '制作精良的古装巨制，服化道考究剧情引人入胜，国风美学视觉盛宴',
    platform: '红桃视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20urban%20drama%20poster%20style%20with%20warm%20soft%20lighting%2C%20modern%20city%20backdrop%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20contemporary%20Chinese%20drama%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '都市',
    title: '樱桃视频都市情感 · 走心好剧推荐',
    desc: '贴近生活的都市情感故事，真实细腻触动人心，引发共鸣的精品剧集',
    platform: '樱桃视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20movie%20collection%20poster%20style%20with%20cinematic%20warm%20golden%20tones%2C%20film%20reel%20aesthetic%2C%20classic%20movie%20atmosphere%2C%20elegant%20composition%2C%20professional%20cinematic%20lighting&width=800&height=500&seq=card-07&orientation=landscape',
    tag: '电影',
    title: '茄子视频电影专区 · 大片随心看',
    desc: '国内外高分电影精选，动作、喜剧、科幻类型丰富，周末观影指南看这里',
    platform: '茄子视频',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            精选各大平台热门内容，好片不错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.platform}</span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
          <div className="col-span-full text-center mt-2">
            <span className="text-xs text-foreground-500">
              共收录 {cards.length} 部精选推荐，持续更新中
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}